/**
 * NovaEventTracker - fires tracking events to our own backend,
 * independent of GA4/GTM and cookie consent.
 */
class NovaEventTracker {
    trackSoftConversion({ componentName = null, cityOverride } = {}) {
        const payload = {
            country_code: window.country?.code ?? null,
            page_group: this.derivePageGroup(),
            // neutral / ic_landing / landing / ic_form / em_form / other, from GlobalDataProvider::trackingPageType()
            page_type: window.trackingPageType ?? null,
            url: window.location.href,
            city: this.resolveSoftConversionCity(cityOverride),
            component_name: componentName,
        };

        if (window.page === 'home_city') {
            payload.is_campaign_page = window.isCampaignPage === true;
            payload.is_young_couriers = window.isYoungCouriers === true;
        }

        this.sendEvent(payload);
    }

    resolveSoftConversionCity(cityOverride) {
        const fromOverride =
            cityOverride != null && String(cityOverride).trim() !== ''
                ? String(cityOverride).trim().toLowerCase()
                : null;
        const c = window.currentCity;
        const fromPage =
            c == null ? null : [c.slug, c.tracking_name].find((x) => x != null && String(x).trim() !== '') ?? null;
        return fromOverride ?? (fromPage != null ? String(fromPage).toLowerCase() : null);
    }

    derivePageGroup() {
        const pageGroup = window.pageGroup ?? null;
        if (pageGroup === 'home' && window.currentCity?.slug) {
            return 'home_city';
        }
        return pageGroup;
    }

    sendEvent(payload) {
        const url = `${window.apiUrl}/tracking/events`;

        if (navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(payload)], {
                type: 'application/json',
            });
            const sent = navigator.sendBeacon(url, blob);
            if (sent) return;
        }

        try {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                keepalive: true,
            });
        } catch {
            // silent fail
        }
    }
}

export const novaEventTracker = new NovaEventTracker();
